import { useState } from "react";
import { useTranslation } from "react-i18next";
import Job from "./Job";
import TimeOff from "./TimeOff";
import { cn } from "../../../../../lib/utils";

const tabs = ["job", "time-off"] as const;
type Tab = typeof tabs[number];

function History({ user }: any) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<Tab>("job");

    return (
        <div className="tw-border tw-rounded-xl tw-overflow-hidden tw-flex tw-flex-col">
            <div className="tw-flex tw-border-b">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        type="button"
                        onClick={() => setActiveTab(tab)}
                        className={cn(
                            "tw-px-5 tw-py-3 tw-text-sm tw-font-medium tw-border-b-2 tw--mb-px tw-transition-colors tw-cursor-pointer",
                            activeTab === tab
                                ? "tw-border-primary tw-text-foreground"
                                : "tw-border-transparent tw-text-muted-foreground hover:tw-text-foreground hover:tw-border-muted-foreground"
                        )}
                    >
                        {t(tab)}
                    </button>
                ))}
            </div>

            <div className="tw-p-3">
                {activeTab === "job" ? <Job user={user} /> : <TimeOff user={user} />}
            </div>
        </div>
    );
}

export default History;
